import React, { useMemo } from 'react';
import ProgressBar from './ProgressBar';
import Corner from './Corner';

export interface BordersProgressBarProps {
  progress?: number;
  isAnimation?: boolean;
  className?: string;
}

const ANIMATION_DURATION = 20;

function BordersProgressBar(props: BordersProgressBarProps) {
  const [animationProgress, setAnimationProgress] = React.useState(0);

  // Create a use efect with a timer to update the animation progress
  React.useEffect(() => {
    if (props.isAnimation) {
      const timer = setInterval(() => {
        setAnimationProgress((prev) => {
          if (prev >= ANIMATION_DURATION) {
            return 0;
          }

          return prev + 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [props.isAnimation]);

  const progress = useMemo(() => {
    if (!props.isAnimation) return props.progress;

    if (animationProgress === 0) return 0;

    return (animationProgress / ANIMATION_DURATION) * 100;
  }, [props.progress, props.isAnimation, animationProgress]);

  return (
    <>
      <Corner position="topLeft" progress={progress} />
      <ProgressBar position="top" progress={progress} />

      <Corner position="topRight" progress={progress} />
      <ProgressBar position="right" progress={progress} />

      <Corner position="bottomRight" progress={progress} />
      <ProgressBar position="bottom" progress={progress} />

      <Corner position="bottomLeft" progress={progress} />
      <ProgressBar position="left" progress={progress} />
    </>
  );
}

export default BordersProgressBar;
